export const subNavLinks = [
  { link: './dashboard', name: 'Dashboard', tanslateId: 'header.links.dashboard' },
  { link: '/redeem', name: 'Redeem', tanslateId: 'header.links.redeem' },
  { link: '/history', name: 'History', tanslateId: 'header.links.history' },
];
